import { PlansRow, SubscriptionPlan } from "@/types";

export const pricingData = (m: any): SubscriptionPlan[] => [
  {
    title: m.starter_label(),
    description: m.mushy_zesty_pelican_jump(),
    benefits: [m.starter_tip_1(), m.starter_tip_2(), m.starter_tip_3()],
    limitations: [
      m.starter_limit_1(),
      m.starter_limit_2(),
      m.starter_limit_3(),
      m.starter_limit_4(),
    ],
    prices: {
      monthly: 0,
      yearly: 0,
      lifetime: 0,
      inneos_lifetime: 0,
      inneos_yearly: 0,
      kevin_lifetime: 0,
    },
    stripeIds: {
      monthly: null,
      yearly: null,
      lifetime: null,
      inneos_lifetime: null,
      inneos_yearly: null,
      kevin_lifetime: null,
    },
  },
  {
    title: m.premium_label(),
    description: m.stout_fair_warthog_dazzle(),
    benefits: [
      m.flat_spicy_gecko_trust(),
      m.east_arable_shad_trim(),
      m.slow_plane_lion_taste(),
      m.wise_quiet_anaconda_hunt(),
      m.noble_jumpy_shrike_grip(),
      m.heroic_ago_walrus_flop(),
    ],
    limitations: [],
    prices: {
      monthly: 0,
      yearly: 490,
      lifetime: 499,
      inneos_lifetime: 499,
      inneos_yearly: 0,
      kevin_lifetime: 499,
    },
    stripeIds: {
      monthly: null,
      yearly: process.env.NEXT_PUBLIC_STRIPE_premium_2026_PLAN_ID!,
      lifetime: process.env.NEXT_PUBLIC_STRIPE_premium_LIFETIME_PLAN_ID!,
      inneos_yearly:
        process.env.NEXT_PUBLIC_STRIPE_premium_INNEOS_YEARLY_PLAN_ID!,
      inneos_lifetime:
        process.env.NEXT_PUBLIC_STRIPE_premium_INNEOS_Lifetime_PLAN_ID!,
      kevin_lifetime:
        process.env.NEXT_PUBLIC_STRIPE_premium_KEVIN_Lifetime_PLAN_ID!,
    },
  },
];

export const plansColumns = (m: any) => [m.starter(), m.premium()] as const;

export const comparePlans = (m: any): PlansRow[] => {
  return [
    {
      feature: m.connected_exchanges(),
      starter: "1",
      premium: m.unlimited(),
      tooltip: m.close_nimble_crocodile_amaze(),
    },
    {
      feature: m.paper_account(),
      starter: false,
      premium: m.unlimited(),
      tooltip: m.every_cute_vulture_create(),
    },
    {
      feature: m.smart_allocation(),
      starter: null,
      premium: true,
      tooltip: m.just_knotty_zebra_cherish(),
    },
    {
      feature: m.auto_rebalancing(),
      starter: null,
      premium: true,
      tooltip: m.topical_slow_liger_embrace(),
    },
    {
      feature: m.dark_pretty_sloth_gleam(),
      starter: null,
      premium: true,
      tooltip: m.arable_tasty_reindeer_mend(),
    },
    {
      feature: m.backtest(),
      starter: true,
      premium: true,
      tooltip: m.ok_front_robin_advise(),
    },
    {
      feature: m.spicy_cool_frog_hope(),
      starter: false,
      premium: true,
      tooltip: m.upper_tame_porpoise_flip(),
    },
    {
      feature: m.many_vexed_osprey_promise(),
      starter: true,
      premium: true,
      tooltip: m.ideal_east_worm_pet(),
    },
    {
      feature: m.this_agent_termite_smile(),
      starter: false,
      premium: true,
      tooltip: m.glad_full_vole_agree(),
    },
    {
      feature: m.formal_bland_hound_propel(),
      starter: null,
      premium: true,
      tooltip: m.pink_lucky_falcon_buzz(),
    },
    {
      feature: m.lucky_giant_elephant_file(),
      starter: true,
      premium: true,
      tooltip: m.chunky_mellow_penguin_wish(),
    },
    {
      feature: m.weird_keen_kestrel_cheer(),
      starter: m.limited(),
      premium: true,
      tooltip: m.jumpy_trite_loris_work(),
    },

    {
      feature: m.aloof_mushy_blackbird_jump(),
      starter: true,
      premium: true,
      tooltip: m.jolly_fuzzy_parakeet_fade(),
    },

    // Add more rows as needed
  ];
};
